
import React from "react";

export const CrossReactionCapIcon = (props: React.HTMLAttributes<SVGElement>) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      version="1.1"
      id="svg1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      >
      <path
        id="Union-1"
        d="m 4.9274384,6.5091097 1.7854422,1.7854272 c 0.140606,0.140592 0.36851,0.140592 0.509102,0 0.140592,-0.1405917 0.140592,-0.3684956 0,-0.5091025 L 5.4365554,5.9999929 7.2219826,4.2145513 c 0.140592,-0.1405872 0.140592,-0.3685296 0,-0.5091168 -0.140592,-0.1405886 -0.368496,-0.1405886 -0.509102,0 L 5.0451854,5.2744454 c 0,0 -0.772678,0.5401148 -0.117747,1.2346643 z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

